<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Report Expired Points</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /
      <b>Loyalty Point System</b>
      /
      <b>Report</b>
      /
      <b>Expired Points</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- TBA -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              Expired Points
            </h4>

            <!-- <p>The table below shows call requests for TBA.</p> -->

            <div class="row">
              <div class="col-6">
                <label><b>Date From</b></label>
                <input type="date" class="form-control" v-model="dateFrom">
              </div>
              <div class="col-6">
                <label><b>Date To</b></label>
                <input type="date" class="form-control" v-model="dateTo">
              </div>
            </div>

            <br>

            <div class="text-left">
              {{dateFromFormatted != null && dateToFormatted != null ? `Reported Date from ${dateFromFormatted} to ${dateToFormatted}` : ''}}
            </div>

            <div class="text-right">
              <button class="btn btn-rounded btn-primary mr-2" style="width: 150px;" @click="filterSearch()">
                Filter
              </button>
              <button class="btn btn-rounded btn-primary" style="width: 150px;" @click="resetFilter()">
                Reset
              </button>
            </div>

            <br>

            <div class="d-flex flex-row p2 mb-2 justify-content-between">
              <json-excel class="btn btn-rounded btn-primary mr-1" style="width: 150px" :fetch="exportData"
                :fields="json_fields" type="csv" worksheet="My Worksheet" name="Expired Points.csv">
                Excel
              </json-excel>
              <div class="d-flex flex-row">
                <div class="form-outline ">
                  <input type="input" v-model="searchItem" class="form-control" />
                </div>
                <button type="button" @click="searchFor" class="btn btn-primary">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>

            <br>

            <div class="table-responsive">
              <table
                id="expired_point_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>Account No</th>
                    <th>Name</th>
                    <th>IC No</th>
                    <th>Points</th>
                    <th>Expired On</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="lists.length == 0">
                    <td colspan="3">No records found</td>
                  </tr>
                  <tr v-for="(list, index) in lists" :key="index">
                    <td>
                        <router-link :to="goTo(list.ic_number)">{{list.account_number}}</router-link>
                    </td>
                    <td>{{ list.name }}</td>
                    <td>{{ list.ic_number }}</td>
                    <td>{{ list.points }}</td>
                    <td>
                      <span class="spanDateTime">{{ list.expired_at }}</span
                      >{{ list.expired_at | moment("DD/MM/YYYY") }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <pagination
                v-model="pageInfo.current_page"
                :per-page="pageInfo.per_page"
                :records="pageInfo.total"
                @paginate="loadPageChange"
              />
            </div>
          </div>
        </div>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";
import Loading from "vue-loading-overlay";
import Pagination from "vue-pagination-2";
import JsonExcel from "vue-json-excel";
import "vue-loading-overlay/dist/vue-loading.css";
import { getRequest } from "@/services/RequestService";

export default {
  name: "report-expired-points",
  components: {
    Loading,
    Pagination,
    JsonExcel,
  },

  data() {
    return {
      lists: [],
      expired_points: [],
      pageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0
      },
      isLoading: false,
      fullPage: true,
      dateFrom: null,
      dateTo: null,
      dateFromFormatted: null,
      dateToFormatted: null,
      searchItem: null,


      json_fields: {
        "Account No": "account_number",
        "IC Number": "ic_number",
        "Points": "points",
        "Expiry Date": "expired_at",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    };
  },

  methods: {
    async loadData() {
      this.downloadApi = '/report/summary/expired/points?export=1';
      
      try {
        let result = await axios.get(axios.lpsURL + `/report/summary/expired/points`, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.lists = result.data.expired_points;
        this.pageInfo = result.data.pagination;

      } catch (e) {
        console.log(e);
        return
      }
    },

    async loadPageChange(page) {
      this.isLoading = true;
      await this.handlePageChange(page);
      this.isLoading = false;
    },

    async handlePageChange(page) {
      let api_url = `/report/summary/expired/points?page=${page}`;

      if(this.dateFrom != null && this.dateTo != null) {
        api_url += `&date_from=${this.dateFrom}&date_to=${this.dateTo}`;
      }

      if(this.searchItem != null) {
        api_url += `&search=${this.searchItem}`;
      }

      // if((this.dateFrom == null || this.dateFrom == '') && (this.dateTo == null || this.dateTo == '')) {
      //   api_url = `/report/summary/expired/points?page=${page}`;
      // } else {
      //   api_url = `/report/summary/expired/points?date_from=${this.dateFrom}&date_to=${this.dateTo}&page=${page}`;
      // }

      try {
        let result = await axios.get(axios.lpsURL + api_url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });
  
        this.lists = result.data.expired_points;
        this.pageInfo = result.data.pagination;
      } catch (e) {
        console.log(e)
      }
    },

    async loadFilter() {
      this.dateFromFormatted = moment(this.dateFrom).format('DD MMMM YYYY');
      this.dateToFormatted = moment(this.dateTo).format('DD MMMM YYYY');

      let api_url = `/report/summary/expired/points?date_from=${this.dateFrom}&date_to=${this.dateTo}`
      this.downloadApi = api_url + `&export=1`;

      try {
        let result = await axios.get(axios.lpsURL + api_url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });
  
        this.lists = result.data.expired_points;
        this.pageInfo = result.data.pagination;
      } catch (e) {
        console.log(e)
      }
    },

    async filterSearch() {
      this.isLoading = true;
      await this.loadFilter();
      this.isLoading = false;
    },

    goTo(ic_no) {
      return "/customer/" + ic_no;
    },

    checkToken() {
      let token = localStorage.getItem("token");

      if (token === null || token === "") {
        return false;
      }
      
      token = JSON.parse(token);
      token = token.access_token;

      return token;
    },

    async resetFilter() {
      await this.loadData();
      this.dateFromFormatted = null;
      this.dateToFormatted = null;
      this.dateFrom = null;
      this.dateTo = null;
      this.searchItem = null;
    },

    async searchFor() {
      let page = 1

      this.isLoading = true;

      let api_url = `/report/summary/expired/points?page=${page}&search=${this.searchItem}`;
      this.downloadApi = `/report/summary/expired/points?search=${this.searchItem}&export=1`;
      if (this.searchItem == null || this.searchItem == "") {
        api_url = `/report/summary/expired/points`;
      }

      if (!this.checkToken()) {
        console.log("Unauthorised");
        this.isLoading = false;
        return;
      }
      try {
        let result = await axios.get(axios.lpsURL + api_url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.lists = result.data.expired_points;
        this.pageInfo = result.data.pagination;
        this.isLoading = false;
      } catch (e) {
        console.log(e);
      }
    },

    setDatatable() {
      $("#expired_point_tbl").DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
          },
          {
            extend: "pdfHtml5",
          }
        ]
      });
    },

    async exportData() {
      // clear json_data
      this.json_data = [];

      this.isLoading = true;

      let result = await axios.get(axios.lpsURL + this.downloadApi, {
        headers: {
          Authorization: "Bearer " + this.checkToken()
        }
      });

      this.expired_points = result.data.expired_points;
      for (let i = 0; i < this.expired_points.length; i++) {
        this.json_data.push({
          account_number: this.expired_points[i].account_number,
          ic_number: this.expired_points[i].ic_number,
          points: this.expired_points[i].points,
          expired_at: this.expired_points[i].expired_at,
        });
      }

      this.isLoading = false;

      return this.json_data;

    },
  },

  async created() {
    await this.loadData();
  }
};
</script>

<style>
.spanDateTime {
  display: none;
}
</style>
